export default __webpack_public_path__ + "static/media/icon-step-three.850b4fc9.png";